import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import useNavigateCart from '~/hooks/useNavigateCart';

import { cartStore } from '~/stores';

import CartCard from '../CartCard/CartCard';
import Price from '../Price';

export default observer(({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation();

  const handleNavigateCart = useNavigateCart({
    source: 'ModalCart',
    afterNavigate: onClose,
  });

  useEffect(() => {
    cartStore.enableCalculate();
    return () => cartStore.disableCalculate();
  }, []);

  return (
    <div className="cart-popover-container" data-company={company.name}>
      <div
        className="cart-popover"
        onClick={(e) => {
          e.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
          e.preventDefault();
        }}
      >
        <div className="popover__title-container">
          <p className="popover__title">{t('yourCart')}</p>
          {company.showCartModalCount && (
            <p className="popover__count">
              {t('phrases:itemsCount', { count: cartStore.totalCartCount })}
            </p>
          )}
        </div>
        <ul className="popover__list">
          {cartStore.cart.map((offer) => (
            <li key={offer.sku}>
              <CartCard
                location="modalCart"
                className="popover__list-item"
                item={offer}
                size="s"
              />
            </li>
          ))}
        </ul>
        {/* {cartStore.totalCartPrice.totalDeliveryPricePence > 0 && (
          <div className="popover__status">
            <div className="popover__status-description">
              <div className="popover__status-description-header">
                <div className="popover__status-description-header-text">
                  <p>{t('add')}</p>
                  <div className="popover__status-description-header-text-marked">
                    {formatPriceWithCurrency(cartStore.leftUntilFreeDelivery[0])}
                  </div>
                  <p>{t('toGetFreeDelivery')}</p>
                </div>
              </div>
            </div>
            <div className="popover__status-line">
              <div
                className="popover__status-line-fill"
                style={{
                  width: cartStore.leftUntilFreeDelivery[1],
                  transition: 'all 0.3s',
                }}
              />
            </div>
          </div>
        )} */}
        <div className="popover__button-container">
          <div
            className="button _primary popover__button"
            onClick={handleNavigateCart}
          >
            <span>{t('goToCart')}</span>
            {company.showCartModalCount && (
              <Price
                price={cartStore.totalCartPrice.paidWithDiscount}
                classNameCurrentPrice="price"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
